let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Gym2")).then(() => parcelRequire('1xWR7'));